// Each city's credits, only while its network is on the map. MapLibre's
// attribution control lists the attribution of every source a visible layer
// uses (and the basemap's, from CARTO's TileJSON), so each region gets a
// source with no data carrying its credits, and a layer on it that is shown
// only while the region is drawn. At world zoom that's none: the line reads
// MapLibre and the basemap's credits. A region's source is added the first
// time it's drawn, when its credits (its code, regions.ts) are in.

import type { Map as MapLibreMap } from 'maplibre-gl';
import type { LoadedRegion } from './regions.ts';

const layerOf = (id: string): string => `credits-${id}`;

export function addCredits(map: MapLibreMap): (shown: readonly LoadedRegion[]) => void {
  const added = new Set<string>();
  return (shown) => {
    for (const r of shown) {
      if (added.has(r.id)) continue;
      added.add(r.id);
      map.addSource(layerOf(r.id), {
        type: 'geojson',
        data: { type: 'FeatureCollection', features: [] },
        attribution: r.credits.join(' | '),
      });
      map.addLayer({ id: layerOf(r.id), type: 'circle', source: layerOf(r.id), layout: { visibility: 'none' } });
    }
    const on = new Set(shown.map((r) => r.id));
    for (const id of added) map.setLayoutProperty(layerOf(id), 'visibility', on.has(id) ? 'visible' : 'none');
  };
}
